module.exports = __webpack_public_path__ + "img/coin-transfer-in.29e1fcea.png";